<template>
  <vuestic-layout v-layout>
    <div class="ddh-sidebar" :class="opened ? 'show-sidebar' : 'hide-sidebar'">
      <div class="sidebar-fixed-gestor">
        <div>
          <div class="menu-control" v-if="isMobile">
            <i class="" v-if="!opened" @click="toggleSidebar(true)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
              >
                <g fill="#fff" fill-rule="evenodd" transform="translate(7 9)">
                  <rect width="22" height="3" rx="1.5" />
                  <rect width="22" height="3" y="8" rx="1.5" />
                  <path
                    d="M0 17.5c0-.828.67-1.5 1.495-1.5h19.01c.826 0 1.495.666 1.495 1.5 0 .828-.67 1.5-1.495 1.5H1.495A1.494 1.494 0 0 1 0 17.5z"
                  />
                </g>
              </svg>
            </i>
            <i class="" v-if="opened" @click="toggleSidebar(false)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="36"
                viewBox="0 0 37 36"
              >
                <g
                  fill="#fff"
                  fill-rule="evenodd"
                  transform="translate(9.867 9)"
                >
                  <rect
                    width="22"
                    height="3"
                    x="-2"
                    y="8"
                    rx="1.5"
                    transform="rotate(45 9 9.5)"
                  />
                  <rect
                    width="22"
                    height="3"
                    x="-2"
                    y="8"
                    rx="1.5"
                    transform="scale(-1 1) rotate(45 0 -12.228)"
                  />
                </g>
              </svg>
            </i>
          </div>
          <span class="logo">
            <img
              width="127"
              :src="require('@/assets/primary.svg')"
              alt="Dentro Educa"
              class
            />
          </span>
        </div>

        <div class="ddh-sidebar-items">
          <ul>
            <li>
              <div class="person-menu" v-if="isMobile">
                <router-link :to="{ name: 'summary' }">
                  <span class="ico-menu">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                    >
                      <defs>
                        <path
                          id="a"
                          d="M9.868 26.825A11.968 11.968 0 0 1 6 18c0-6.627 5.373-12 12-12s12 5.373 12 12c0 3.49-1.49 6.632-3.868 8.825a8.73 8.73 0 0 0-16.264 0zM18 11.455a4.364 4.364 0 1 0 0 8.727 4.364 4.364 0 0 0 0-8.727z"
                        />
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                        <!-- <path fill="#FFF" d="M-568-206H872v753H-568z"/> -->
                        <g>
                          <circle
                            cx="18"
                            cy="18"
                            r="12"
                            stroke="#fff"
                            stroke-width="2"
                          />
                          <use fill="#fff" xlink:href="#a" />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span>{{ principalCredential.user.name }}</span>
                </router-link>
              </div>
            </li>

            <!-- <li v-if="!isMobile">
              <router-link :to="{ name: 'projects' }">
                <span class="ico-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon d-block mr-10" width="32" height="32" viewBox="0 0 32 32"><title>Ícone de Usuário</title><g fill="none" fill-rule="evenodd" transform="translate(2 2)"><circle cx="14" cy="14" r="14.5" stroke="#01DFA1" fill="#01DFA1"></circle><path fill="#FFF" d="M4.06 23.859A13.957 13.957 0 0 0 14 28c3.887 0 7.403-1.584 9.94-4.141a8.003 8.003 0 0 0-7.758-6.04h-4.364a8.003 8.003 0 0 0-7.758 6.04zm9.85-17.495h.18a5 5 0 0 1 5 5v.181a5 5 0 0 1-5 5h-.18a5 5 0 0 1-5-5v-.181a5 5 0 0 1 5-5z"></path></g>
                  </svg>
                </span>
                <span>Adoções</span>
              </router-link>
            </li> -->

            <li v-if="projectsList.length">
              <div class="va-row">
                <div class="flex xs12">
                  <select-normal
                    :items="projectsList"
                    :value="currentProjectId"
                    class="selectProject"
                    label="Selecione um projeto"
                    name="project_id"
                    @change="onChangeProjectId($event)"
                  />
                </div>
              </div>
            </li>

            <li>
              <router-link :to="{ name: 'schedule' }">
                <span class="ico-menu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.57124 5.28572C8.57124 4.02335 9.59459 3 10.857 3C12.1193 3 13.1427 4.02335 13.1427 5.28571V6.42858H18.8572V5.28572C18.8572 4.02335 19.8806 3 21.1429 3C22.4053 3 23.4286 4.02335 23.4286 5.28571V6.42858H25.3333C26.8061 6.42858 28 7.62249 28 9.09525V26.3333C28 27.8061 26.8061 29 25.3333 29H6.66667C5.19391 29 4 27.8061 4 26.3333V9.09525C4 7.62249 5.19391 6.42858 6.66667 6.42858H8.57124V5.28572ZM6.28577 14.4286V25.3618C6.28577 26.0982 6.88273 26.6951 7.61911 26.6951H24.381C25.1174 26.6951 25.7143 26.0982 25.7143 25.3618V14.4286H6.28577Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span>Cronograma</span>
              </router-link>
            </li>

            <li>
              <router-link :to="{ name: 'director-my-class' }">
                <span class="ico-menu">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 29 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.6669 18.5666C27.378 18.5666 27.1391 18.4722 26.9503 18.2833C26.7614 18.0944 26.6669 17.8555 26.6669 17.5666V9.1666L14.9336 15.4999C14.778 15.5888 14.6225 15.6499 14.4669 15.6833C14.3114 15.7166 14.1447 15.7333 13.9669 15.7333C13.7891 15.7333 13.628 15.7166 13.4836 15.6833C13.3391 15.6499 13.1891 15.5888 13.0336 15.4999L0.933594 8.8666C0.755816 8.77771 0.628038 8.65549 0.55026 8.49994C0.472483 8.34438 0.433594 8.17771 0.433594 7.99994C0.433594 7.82216 0.472483 7.65549 0.55026 7.49994C0.628038 7.34438 0.755816 7.22216 0.933594 7.13327L13.0003 0.533268C13.1558 0.444379 13.3114 0.377713 13.4669 0.333268C13.6225 0.288824 13.7891 0.266602 13.9669 0.266602C14.1447 0.266602 14.3114 0.288824 14.4669 0.333268C14.6225 0.377713 14.778 0.444379 14.9336 0.533268L28.1336 7.69993C28.3114 7.81105 28.4447 7.94438 28.5336 8.09994C28.6225 8.25549 28.6669 8.42216 28.6669 8.59994V17.5666C28.6669 17.8555 28.5725 18.0944 28.3836 18.2833C28.1947 18.4722 27.9558 18.5666 27.6669 18.5666ZM13.9669 23.6999C13.7891 23.6999 13.6225 23.6833 13.4669 23.6499C13.3114 23.6166 13.1558 23.5555 13.0003 23.4666L5.33359 19.2666C5.02248 19.0888 4.77248 18.8444 4.58359 18.5333C4.3947 18.2222 4.30026 17.8777 4.30026 17.4999V11.6999L12.6003 16.2333C12.8225 16.3444 13.0447 16.4555 13.2669 16.5666C13.4891 16.6777 13.7225 16.7333 13.9669 16.7333C14.2114 16.7333 14.4503 16.6777 14.6836 16.5666C14.9169 16.4555 15.1447 16.3444 15.3669 16.2333L23.6336 11.6999V17.4999C23.6336 17.8777 23.5391 18.2222 23.3503 18.5333C23.1614 18.8444 22.9114 19.0888 22.6003 19.2666L14.9336 23.4666C14.778 23.5555 14.6225 23.6166 14.4669 23.6499C14.3114 23.6833 14.1447 23.6999 13.9669 23.6999Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span>Minhas Turmas</span>
              </router-link>
            </li>

            <!-- <li>
							<router-link
								id="btn-classes"
								:to="{ name: 'grades-director-manage' }"
							>
								<span class="ico-menu">
									<svg width="32" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M17.018 4.22953C16.8798 1.86179 14.9069 0 12.5057 0C10.0999 0 8.11431 1.87066 7.98657 4.25131C4.47937 5.92562 2.04772 9.48218 2.04772 13.6159C2.04772 13.8782 2.05803 14.1379 2.07768 14.3945C0.0628843 15.6819 -0.610586 18.3349 0.609546 20.4274C1.82494 22.5118 4.46319 23.2567 6.58885 22.174C8.27663 23.3266 10.3214 24 12.5222 24C14.7157 24 16.7543 23.331 18.4388 22.1854C20.5601 23.2505 23.1806 22.5022 24.3905 20.4246C25.6018 18.3471 24.9467 15.7171 22.9656 14.4196C22.9864 14.1525 22.9967 13.8834 22.9967 13.613C22.9967 9.46367 20.5466 5.89584 17.018 4.22953ZM10.5111 4.49537C10.5111 3.42357 11.3912 2.533 12.5057 2.533C13.6174 2.533 14.4947 3.42068 14.4947 4.49537C14.4947 4.61207 14.4844 4.72959 14.4648 4.84604C14.3006 5.7513 13.4902 6.45773 12.5029 6.45773C11.5144 6.45773 10.705 5.75307 10.541 4.8462C10.5213 4.7297 10.5111 4.61213 10.5111 4.49537ZM8.60559 6.78145C6.19526 8.13491 4.57874 10.6927 4.57874 13.6159C4.57874 13.6373 4.57884 13.6587 4.57902 13.6801C6.11733 13.7003 7.60766 14.5001 8.43882 15.9201L8.43982 15.9218C9.27156 17.3478 9.22425 19.0338 8.4715 20.371C9.65655 21.0674 11.0403 21.467 12.5222 21.467C13.9908 21.467 15.3629 21.0746 16.5408 20.3898C15.7765 19.0495 15.724 17.3535 16.5596 15.9199C17.3978 14.4799 18.9106 13.6806 20.4654 13.6765C20.4656 13.6554 20.4657 13.6342 20.4657 13.613C20.4657 10.6784 18.8365 8.11202 16.4105 6.76275C15.6234 8.09877 14.1632 8.99074 12.5029 8.99074C10.8505 8.99074 9.39531 8.10855 8.60559 6.78145ZM18.7466 17.1949C19.2313 16.3621 20.2504 16.0049 21.1511 16.3256C21.2672 16.3685 21.376 16.4186 21.4774 16.4763C22.4304 17.0242 22.7451 18.2207 22.2044 19.1479C21.6585 20.086 20.4357 20.4186 19.4737 19.8676L19.4721 19.8667C19.3707 19.8088 19.2741 19.7413 19.1824 19.6648C18.4611 19.061 18.2643 18.0219 18.7466 17.1949ZM3.52271 16.4791C3.62416 16.4213 3.73303 16.3713 3.84923 16.3283C4.74362 16.009 5.76525 16.3648 6.2544 17.1995C6.73627 18.0266 6.53859 19.0644 5.81715 19.668L5.80857 19.6752C5.73918 19.7343 5.64624 19.7995 5.52125 19.8733C4.55922 20.4179 3.34002 20.0845 2.79558 19.1508C2.25493 18.2236 2.56964 17.0269 3.52271 16.4791Z" fill="white"/>
									</svg>

								</span>
								<span>Turmas</span>
							</router-link>
						</li> -->

            <li>
              <router-link :to="{ name: 'director-books' }">
                <span class="ico-menu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.66675 4C7.56218 4 6.66675 4.89543 6.66675 6V26C6.66675 27.1046 7.56218 28 8.66675 28H23.3334C24.438 28 25.3334 27.1046 25.3334 26V25.3333L10.3334 25.3333C9.59703 25.3333 9.00008 24.7364 9.00008 24C9.00008 23.2636 9.59704 22.6667 10.3334 22.6667L25.3334 22.6667V6C25.3334 4.89543 24.438 4 23.3334 4H8.66675Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span>Livros</span>
              </router-link>
            </li>

            <!-- <li v-if="principalCredential.settings.active_salesperson">
							<router-link :to="{ name: 'director-payment' }">
								<span class="ico-menu">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="36"
										height="36"
										viewBox="0 0 36 36"
									>
										<g fill="none" fill-rule="evenodd">
											<path
												fill="#000"
												d="M18.677 7.238a1.07 1.07 0 0 0-1.348 0l-8.915 7.145c-.262.21-.414.528-.414.864v11.64c0 .607.487 1.1 1.086 1.1l5.698.013a1.086 1.086 0 0 0 1.089-1.099v-5.817c0-.608.486-1.102 1.085-1.102h2.084c.602 0 1.088.494 1.088 1.102v5.814c0 .611.49 1.105 1.089 1.102l5.699-.015A1.094 1.094 0 0 0 28 26.883V15.247c0-.336-.152-.657-.414-.864l-8.91-7.145z"
											/>
										</g>
									</svg>
								</span>
								<span>Pagamento</span>
							</router-link>
						</li> -->

            <!-- <li v-if="!isMobile">
              <router-link :to="{ name: 'dashboard' }">
                <span class="ico-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#000" d="M18.677 7.238a1.07 1.07 0 0 0-1.348 0l-8.915 7.145c-.262.21-.414.528-.414.864v11.64c0 .607.487 1.1 1.086 1.1l5.698.013a1.086 1.086 0 0 0 1.089-1.099v-5.817c0-.608.486-1.102 1.085-1.102h2.084c.602 0 1.088.494 1.088 1.102v5.814c0 .611.49 1.105 1.089 1.102l5.699-.015A1.094 1.094 0 0 0 28 26.883V15.247c0-.336-.152-.657-.414-.864l-8.91-7.145z"/>
                      </g>
                  </svg>
                </span>
                <span>Dashboard</span>
              </router-link>
            </li> -->

            <!-- <li v-if="!isMobile">
              <router-link :to="{ name: 'dashboard' }">
                <span class="ico-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#000" d="M18.677 7.238a1.07 1.07 0 0 0-1.348 0l-8.915 7.145c-.262.21-.414.528-.414.864v11.64c0 .607.487 1.1 1.086 1.1l5.698.013a1.086 1.086 0 0 0 1.089-1.099v-5.817c0-.608.486-1.102 1.085-1.102h2.084c.602 0 1.088.494 1.088 1.102v5.814c0 .611.49 1.105 1.089 1.102l5.699-.015A1.094 1.094 0 0 0 28 26.883V15.247c0-.336-.152-.657-.414-.864l-8.91-7.145z"/>
                      </g>
                  </svg>
                </span>
                <span>Dashboard Representantes</span>
              </router-link>
            </li> -->

            <!-- <li>
              <router-link :to="{ name: 'teachers' }">
                <span class="ico-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#000" d="M18 7c3.314 0 6 2.91 6 6.5S21.314 20 18 20s-6-2.91-6-6.5S14.686 7 18 7zm9.571 19.883c-2.728 4.507-16.414 4.507-19.143 0-1.574-2.602 1.445-5.551 4.919-7.146 1.319 1.067 2.926 1.698 4.66 1.698 1.732 0 3.337-.629 4.655-1.694 3.47 1.595 6.483 4.543 4.91 7.142z"/>
                      </g>
                  </svg>
                </span>
                <span>Professores</span>
              </router-link>
            </li>

            <li>
              <router-link :to="{ name: 'classes' }">
                <span class="ico-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#000" d="M11.386 7h13.3C25.917 7 27 8.088 27 9.394v15.962H12.325c-.94 0-.94 2.322 0 2.322H27C27 28.912 25.916 30 24.687 30H11.386C10.084 30 9 28.912 9 27.606V9.394C9 8.088 10.084 7 11.386 7"/>
                      </g>
                  </svg>
                </span>
                <span>Turmas</span>
              </router-link>
            </li> -->
          </ul>
          <!-- <ul class="clube-dentro">
            <li>
              <span>CLUBE DA  DENTRO</span>
            </li>
            <li v-if="isSubscriber">
              <router-link :to="{ name: 'next-kits' }">Próximos Kits</router-link>
            </li>
            <li v-if="isSubscriber">
              <router-link :to="{ name: 'delivered-kits' }">Kits já enviados</router-link>
            </li>
            <li v-if="isSubscriber">
              <router-link :to="{ name: 'manage-subscribe' }">Gerenciar assinatura</router-link>
            </li>
            <li v-if="!isSubscriber">
              <a href="/clube" class="btn btn-know-more">SAIBA MAIS SOBRE O CLUBE</a>
              <div class="clearfix"></div>
            </li>
          </ul> -->
          <!-- <ul class="no-border-bottom">
            <li>
              <a href="/" target="_blank">
                <span class="ico-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#000" d="M13.718 13c-.842-.23-.963-.599-1.42-.943-.36-.27-.266-.889-.335-1.343-.07-.453.042-.631.303-1.002.541-.765.944-.817 1.686-.26C14.979 10.223 15.767 12.04 16 13h-2.282zm6.282.229c.26-1.069 1.237-3.655 2.622-4.089.932-.292 1.361-.061 1.601.273.295.41.393.983.316 1.488-.077.506-.444.843-.843 1.143-.51.383-.813.854-1.75 1.111L20 13.23zm5.428-.655a3.544 3.544 0 0 0-.058-4.108 3.547 3.547 0 0 0-2.33-1.422 3.55 3.55 0 0 0-2.654.64c-.747.541-1.746 1.739-2.387 3.01-.6-1.188-1.558-2.41-2.384-3.01a3.548 3.548 0 0 0-2.655-.64 3.546 3.546 0 0 0-2.33 1.422 3.544 3.544 0 0 0-.058 4.108H9.237A2.237 2.237 0 0 0 7 14.806c0 1.13.848 2.065 1.942 2.21v9.275A2.716 2.716 0 0 0 11.658 29h12.684a2.715 2.715 0 0 0 2.716-2.71v-9.274A2.235 2.235 0 0 0 29 14.806a2.236 2.236 0 0 0-2.237-2.232h-1.335z"/>
                      </g>
                  </svg>
                </span>
                <span>Livros Personalizados</span>
              </a>
            </li>
            <li>
              <a href="https://dentrodahistoria.zendesk.com/hc" target="_blank">
                <span class="ico-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#000" d="M21.703 16.799c-.458.38-.917.729-1.408 1.046-.72.475-1.146 1.204-1.146 2.155h-2.946c-.131-1.014-.066-2.155.884-2.884.556-.412 1.145-.76 1.604-1.204.426-.444.85-.983 1.047-1.522.23-.697-.327-1.521-.949-1.743-.917-.317-2.03-.063-2.423.666-.229.412-.36.919-.556 1.426h-2.75c-.295-1.426.524-3.17 1.899-4.025 1.898-1.141 5.14-.888 6.809.57 1.67 1.426 1.637 4.089-.065 5.515M17.965 25C16.842 25 16 24.15 16 23.054 16 21.85 16.807 21 17.965 21c1.158-.035 2.035.85 2.035 2.017C20 24.15 19.158 25 17.965 25M16.738 6.09c-5.4.647-9.543 4.525-10.525 9.634-1.228 6.495 2.977 12.835 9.39 14.159.338.062 3.805.4 6.414-.462 4.418-1.723 7.119-4.894 7.917-9.634.03-.092.43-3.97-1.166-7.11-2.118-4.34-6.782-7.233-12.03-6.587"/>
                      </g>
                  </svg>
                </span>
                <span>Central de ajuda</span>
              </a>
            </li>
          </ul> -->

          <div class="encerrar">
            <img
              :src="principalCredential.user.client_logo"
              width="120"
              alt="Logo"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="ddh-header background-gestor">
      <div class="container-dhh va-row justify-right">
        <div class="info-person">
          <div class="ico-person">
            <div class="person-name">
              <div class="ico">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35.8177 19.9938C35.8177 28.7183 28.7416 35.7885 20.0157 35.7885C11.2898 35.7885 4.21375 28.7183 4.21375 19.9938C4.21375 11.2694 11.2898 4.19922 20.0157 4.19922C28.7416 4.19922 35.8177 11.2694 35.8177 19.9938ZM20.0156 23.949C24.0352 23.949 27.53 26.1962 29.3121 29.5028C26.9141 31.8449 23.6336 33.2885 20.0157 33.2885C16.3978 33.2885 13.1173 31.8449 10.7192 29.5027C12.5014 26.1961 15.9961 23.949 20.0156 23.949ZM14.7391 17.3566C14.7391 14.4439 17.1032 12.0827 20.0159 12.0827C22.9286 12.0827 25.2927 14.4439 25.2927 17.3566C25.2927 20.2693 22.9286 22.6305 20.0159 22.6305C17.1032 22.6305 14.7391 20.2693 14.7391 17.3566Z"
                    fill="white"
                  />
                </svg>
              </div>

              <span
                ><b>{{ principalCredential.user.name }}</b>
                <br />
                <span class="type-person"> Gestor escolar </span>
                <svg
                  width="16"
                  height="16"
                  class="fa"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7019 11.9153L16 16.6172L11.2981 11.9153C10.5177 11.1349 9.2556 11.1349 8.47525 11.9153C7.6949 12.6956 7.6949 13.9577 8.47525 14.7381L14.5952 20.8581C15.3756 21.6384 16.6377 21.6384 17.4181 20.8581L23.5381 14.7381C24.3184 13.9577 24.3184 12.6956 23.5381 11.9152L23.5319 11.9092C22.7608 11.1579 21.4898 11.1273 20.7019 11.9153Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </span>

              <div class="menu-dropdown">
                <router-link :to="{ name: 'main' }" class="logout">
                  Encerrar sessão
                </router-link>
              </div>
            </div>

            <!-- <div class="person-name">
						<div class="ico">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="36"
								height="36"
								viewBox="0 0 36 36"
							>
								<defs>
									<path
										id="a"
										d="M9.868 26.825A11.968 11.968 0 0 1 6 18c0-6.627 5.373-12 12-12s12 5.373 12 12c0 3.49-1.49 6.632-3.868 8.825a8.73 8.73 0 0 0-16.264 0zM18 11.455a4.364 4.364 0 1 0 0 8.727 4.364 4.364 0 0 0 0-8.727z"
									/>
								</defs>
								<g fill="none" fill-rule="evenodd">
									<g>
										<circle
											cx="18"
											cy="18"
											r="12"
											stroke="#fff"
											stroke-width="2"
										/>
										<use fill="#fff" xlink:href="#a" />
									</g>
								</g>
							</svg>
						</div>

						<span
							>{{ principalCredential.user.name }}
							<i class="fa fa-chevron-down"></i
						></span>

						<div class="menu-dropdown">
							<router-link :to="{ name: 'main' }" class="logout">
								Encerrar sessão
							</router-link>
						</div>
					</div> -->
          </div>
        </div>
      </div>
    </div>

    <main
      slot="content"
      id="content"
      class="va-layout gutter--lg fluid no-padding"
      role="main"
    >
      <!-- <app-breadcrumbs/>
      <vuestic-pre-loader
        v-show="isLoading"
        class="pre-loader"
      /> -->
      <router-view />
    </main>
    <!-- <span slot="footer">
      ©2019 - Dentro Educa
    </span> -->
  </vuestic-layout>
</template>

<script>
import VuesticLayout from "../../vuestic-theme/vuestic-components/vuestic-layout/VuesticLayout";
import AppNavbar from "./app-navbar/AppNavbar";
import AppSidebar from "./app-sidebar/AppSidebar";
import AppBreadcrumbs from "./app-breadcrumbs/AppBreadcrumbs";
import Layout from "../../vuestic-theme/vuestic-directives/Layout";
import { mapGetters } from "vuex";
const axios = require("axios");

export default {
  name: "app-layout",

  components: {
    VuesticLayout,
    AppNavbar,
    AppSidebar,
    AppBreadcrumbs,
  },
  directives: {
    layout: Layout,
  },

  updated: function () {
    // this.addResize();
    window.addEventListener("resize", this.resizeMenu);
  },

  data() {
    return {
      opened: true,
      isMobile: false,

      name: "",
      lastName: "",

      isSubscriber: false,

      currentRoute: null,
      // errors: []
      projectsList: [],
      currentProjectId: "",
      currentSchoolId: "",
    };
  },

  watch: {
    $route(to, from) {
      this.resizeMenu();
    },
  },

  mounted() {
    const self = this;

    var school_id = self.principalCredential.school_id;

    if (self.principalCredential.project_id.length > 1) {
      //self.projectsList = self.principalCredential.project_id
      var list = [];

      self.principalCredential.project_id.forEach((element) => {
        var itemList = {
          key: element.id,
          value: element.name,
        };

        list.push(itemList);
      });

      self.projectsList = list;

      if (self.principalCredential.currentAdoption) {
        self.currentProjectId = self.principalCredential.currentAdoption.id;
      } else {
        self.currentProjectId = self.projectsList[0].key;
      }

      self.principalCredential.project_id.forEach((element) => {
        if (element.id === self.currentProjectId) {
          school_id = element.school_id;
        }
      });
    } else if (Object.keys(self.principalCredential.project_id).length > 1) {
      var principalToTransform = [];

      Object.keys(self.principalCredential.project_id).forEach(function (k) {
        //console.log(i);
        principalToTransform.push(self.principalCredential.project_id[k]);
      });

      // for (
      // 	var counterProjects = 1;
      // 	counterProjects <
      // 	Object.keys(self.principalCredential.project_id).length;
      // 	counterProjects++
      // ) {
      // 	//console.log(i);
      // 	principalToTransform.push(
      // 		self.principalCredential.project_id[counterProjects]
      // 	);

      // 	// more statements
      // }

      //self.principalCredential.currentAdoption = principalToTransform[0];
      self.currentProjectId = principalToTransform[0].id;
      school_id = principalToTransform[0].school_id;

      // principalCredential.currentAdoption = {
      // 	id: principalToTransform[0].id,
      // 	school_id: principalToTransform[0].id,
      // };
    } else {
      self.currentProjectId = self.principalCredential.project_id;
    }

    // TODO VERIFICAR PROJETO
    // if (Object.keys(self.principalCredential.school_id).length > 0) {
    // 				var list = [];

    // 				var arrayItems = Object.entries(self.principalCredential.project_id);

    // 				arrayItems.forEach((element) => {
    // 					var itemList = {
    // 						key: element[1].id,
    // 						value: element[1].name,
    // 					};

    // 					list.push(itemList);
    // 				});

    // 				self.projectsList = list;

    // 				if (self.projectsList.length > 0) {
    // 					self.currentProjectId = self.projectsList[0].key;

    // 					self.$store.commit("SAVE_PRINCIPAL_CURRENT_ADOPTION", {
    // 						id: self.currentProjectId,
    // 						school_id: school_id,
    // 					});
    // 				} else {
    // 					self.currentProjectId = self.projectsList[0].key;
    // 				}

    // 				self.$store.commit("SAVE_PRINCIPAL_CURRENT_ADOPTION", {
    // 					id: self.currentProjectId,
    // 					school_id: school_id,
    // 				});
    // 			} else {
    // 				self.currentProjectId = self.principalCredential.project_id;

    // 				self.$store.commit("SAVE_PRINCIPAL_CURRENT_ADOPTION", {
    // 					id: self.currentProjectId,
    // 					school_id: school_id,
    // 				});
    // 			}

    self.$store.commit("SAVE_PRINCIPAL_CURRENT_ADOPTION", {
      id: self.currentProjectId,
      school_id: school_id,
    });
  },

  methods: {
    onChangeProjectId(event) {
      const self = this;

      if (event.target.value !== "") {
        self.$store.commit("SAVE_PRINCIPAL_CURRENT_ADOPTION", {
          id: parseInt(event.target.value),
        });
        window.location.reload();
      }
    },

    addResize() {},
    toggleSidebar(opened) {
      this.opened = opened;
    },
    detectSize() {
      var menuStatus = false;
      if (window.innerWidth < 990) {
        menuStatus = true;
      }
      return menuStatus;
    },
    resizeMenu() {
      // var menuStatus = false
      if (window.innerWidth < 990) {
        this.isMobile = true;
        this.opened = false;
      } else {
        this.isMobile = false;
        this.opened = true;
      }
      // return menuStatus
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),

    ...mapGetters({
      principalCredential: "principalCredential",
      // ...
    }),
  },

  // computed: {
  //   ...mapGetters({
  //     //userCredential: 'userCredential',

  //     // ...
  //   })
  // },
};
</script>

<style lang="scss">
.selectProject {
  select {
    border: 1px solid #fff !important;
    //color:white  !important;
    background-color: transparent !important;
    color: #ddd4ff !important;
    padding-right: 40px !important;
    height: 68px;

    option {
      color: #68596e;
    }
  }

  .select-group {
    &:after {
      //color: white !important;
      color: #ddd4ff !important;
      z-index: 2 !important;
    }
  }
}
.encerrar {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
  text-align: center;
  bottom: 13%;
}
.logout {
  &:hover {
    color: red !important;
  }
}
.no-border-bottom {
  border-bottom: none !important;
}
.clube-dentro {
  padding-bottom: 20px !important;
}
.btn-know-more {
  border-radius: 40px;
  border: 1px solid #f1edf5;
  background-color: #fff;
  opacity: 1 !important;
  color: #3bd2d6 !important;
  margin-left: 25px !important;
  font-weight: 900 !important;
  display: block !important;
  width: auto;
  padding: 13px 15px !important;
  float: left;
  margin-bottom: 10px;
}
.ddh-sidebar {
  float: left;
  max-width: 230px;
  width: 100%;
  height: calc(100vh);
  position: relative;
  overflow: hidden;

  .sidebar-fixed-gestor {
    position: fixed;
    width: 100%;
    background-color: #923fda;
    max-width: 230px;
    height: 100%;

    @media (max-width: 990px) {
      width: 100%;
      max-width: 100%;
    }
  }

  &.hide-sidebar {
    height: 89px;

    @media (max-width: 990px) {
      height: 51px;
    }

    .sidebar-fixed {
      width: 100%;
      position: relative;
      max-width: 100%;
    }
  }

  @media (max-width: 990px) {
    max-width: 100%;
    width: 100%;
    overflow: overlay;
    z-index: 2;
    position: relative;
  }

  .logo {
    height: 89px;
    text-align: center;
    padding-top: 22px;
    border-bottom: 1px solid #0dbec4;
    margin-bottom: 10px;
    display: block;

    @media (max-width: 990px) {
      margin-bottom: 0px;
      padding-top: 10px;
      height: 51px !important;

      svg {
        width: 100%;
        max-width: 90px;
      }
    }
    svg {
      margin: 0 auto;
    }
  }

  .menu-control {
    position: absolute;
    left: 20px;
    top: 8px;
    color: white;
    font-size: 24px;
  }
}

.ddh-sidebar-items {
  position: relative;
  height: calc(100vh);

  &.ddh-sidebar-items ul {
    list-style: none;
    padding-left: 0px;
    border-bottom: 1px solid #0dbec4;
    padding-bottom: 10px;

    li {
      a {
        opacity: 0.7;
        position: relative;
        height: 50px;
        padding-left: 25px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        // cursor: pointer;
        text-decoration: none;
        color: white;
        font-weight: 400;

        &:hover {
          color: white;
          opacity: 1;
        }

        &.router-link-active {
          // background-color:#4965bc;
          opacity: 1;
          color: white;

          :before {
            content: "";
            position: absolute;
            width: 5px;
            background-color: #fff;
            left: 0;
            height: 100%;
            top: 0px;
          }
        }
      }

      .person-menu {
        opacity: 0.85;
        position: relative;
        height: 64px;
        padding-left: 25px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: default;
        text-decoration: none;
        // background-color: #4965bc;
        color: white;
        padding-left: 0px;

        a {
          //padding-left: 0px;

          // &.router-link-active{
          //   span{
          //     &:before{
          //       display: none;
          //     }
          //   }
          // }
        }
      }
      svg {
        opacity: 0.85;
        margin-left: -5px;
        margin-right: 10px;
        path {
          fill: #fff;
        }
      }
    }
  }

  .clube-dentro {
    span {
      opacity: 0.7;
      position: relative;
      height: 50px;
      padding-left: 25px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      // cursor: pointer;
      text-decoration: none;
      color: white;
      font-weight: 400;
      font-size: 14px;
      font-weight: bold;
    }
    li:first-child a {
      font-size: 14px;
    }

    li a {
      &.router-link-active {
        // background-color:#4965bc;
        opacity: 1;
        color: white;

        &:before {
          display: block;
          content: "";
          position: absolute;
          width: 5px;
          background-color: #fff;
          left: 0;
          height: 100%;
          top: 0px;
        }
      }
    }

    a {
      height: 40px !important;
    }
  }
}

.background-gestor {
  background-color: #7532ae !important;
  @media (max-width: 990px) {
    width: 100%;
    height: 126px;
    background-color: #7532ae !important;
    display: none;
  }

  .ddh-header {
    width: 100%;
    height: 89px;
  }
  .info-person {
    float: right;
    margin-right: 8px;
    margin-top: 0px;
    cursor: pointer;
    text-transform: uppercase;
    z-index: 9;
    position: relative;
    display: flex;
    align-items: center;
    @media (max-width: 990px) {
      margin: 0 auto;
      margin-top: 12px;
      float: none;
      display: block;
      text-align: center;
    }

    &:hover {
      .ico {
        opacity: 0.65;
      }
      .person-name span {
        opacity: 0.65;
      }
      .person-name .menu-dropdown {
        display: block;
      }
    }

    // &:hover{
    //   .menu-dropdown{
    //     display: block;
    //   }
    // }
    .ico-person {
      // float: left;
      float: left;
      line-height: 1;

      @media (max-width: 990px) {
        float: none;
        width: 100%;
        text-align: center;
      }
    }

    .person-name {
      margin-right: 15px;

      @media (max-width: 990px) {
        display: inline-block;
        position: relative;
      }
      .ico {
        float: left;
        margin-right: 10px;

        svg {
          path {
            fill: #ffffff;
          }
        }
      }

      .menu-dropdown {
        display: none;
        position: absolute;
        top: 50px;
        // border-top: 10px solid #907feb;
        border-radius: 10px;
        width: 260px;
        border-radius: 10px;
        -webkit-box-shadow: 0 2px 4px 0 rgba(175, 162, 186, 0.4);
        box-shadow: 0 2px 4px 0 rgba(175, 162, 186, 0.4);
        background-color: #ffffff;
        padding: 20px;
        padding-top: 0px;
        padding-bottom: 0px;
        right: 15px;

        @media (max-width: 990px) {
          right: 0;
          left: -41px;
          margin-right: auto;
          margin-left: auto;
          top: 50px;
          z-index: 2;
        }

        a {
          font-family: Nunito;
          font-size: 16px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          color: #68596e;
          // border-bottom: 1px solid #dfdae4;
          width: 100%;
          display: block;
          height: 57px;
          position: relative;
          line-height: 60px;
          text-transform: initial;

          &:hover {
            color: #1ad3d9;
          }
          &:last-child {
            border-top: 1px solid #dfdae4;
            border-bottom: 0px;
            font-size: 14px;

            &:before {
              display: none;
            }
          }

          &:before {
            content: "\F054";
            color: #1ad3d9;
            position: absolute;
            top: 24px;
            width: 4px;
            height: 4px;
            font: normal normal normal 14px/1 FontAwesome;
            right: 9px;
            margin-left: auto;
            margin-right: auto;
          }
        }

        &:before {
          content: "\F0D8";
          color: #fff;
          position: absolute;
          top: -10px;
          width: 4px;
          height: 4px;
          font: normal normal normal 14px/1 FontAwesome;
          right: 39%;

          @media (max-width: 990px) {
            right: 0px;
            left: 0px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      }
    }

    span {
      float: left;
      height: auto;
      font-stretch: normal;
      letter-spacing: 0.8px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      text-align: left;

      &:before {
        content: "";
      }
    }

    .type-person {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      /* identical to box height, or 150% */
      text-transform: initial;
      color: #ffffff;
    }

    .fa {
      font-size: 8px;
      position: absolute;
      right: -7px;
    }

    .ico-cart {
      position: relative;
      width: 50px;
      height: 50px;
      border-radius: 100px;
      background-color: #ffffff;
      float: right;
      text-align: center;
      padding-top: 7px;

      svg {
        // position: relative;
        // left: -3px;
        // top: 7px;

        path {
          fill: #afa2ba;
        }
      }

      span {
        position: absolute;
        width: 20px;
        height: 30px;
        top: 8px;
        left: 2px;
        right: 0;
        font-size: 9px;
        text-align: center;
        margin-right: auto;
        margin-left: auto;
      }
    }
  }
}
</style>
